import React, { useContext, useState } from 'react';
import classNames from 'classnames';
import { AccountButton } from '../account-button/AccountButton';
import { AccountMenu } from '../account-menu/AccountMenu';
import { AccountWishList } from '../account-wishlist/AccountWishList';
import { formatGreeting } from '../../utils/user/format-greeting';
import {
  isMin1024pxWide,
  isTouchDevice,
} from '../../utils/device/identifyDevice';
import { UserContext } from '../../scaffold/UserContext';
import { getAccountLinks } from '../links';
import { notifyNavAnalytics } from '../navigation/notify-analytics';

import styles from './account-links.scss';
import { EnvVarsFeaturesContext } from '../../scaffold/EnvVarsFeaturesContext';

export const AccountLinks = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    envVars: { accountBaseUrl, myAccountUrl },
    features,
  } = useContext(EnvVarsFeaturesContext);
  const {
    userState: {
      user: { signedIn, greeting },
    },
  } = useContext(UserContext);

  const shouldHideAccount = features.mvoMode || features.hideAccountIcon;
  const shouldHideWishList = features.mvoMode || features.hideWishListIcon;

  const toggleMenu = e => {
    e.preventDefault();
    setIsMenuOpen(!isMenuOpen);
  };

  const handleOnClickSignedOut = () => {
    if (!isMin1024pxWide()) {
      notifyNavAnalytics('mv', 'Account');
    }
  };

  const handleOnClickSignedIn = e => {
    if (!isMin1024pxWide()) {
      notifyNavAnalytics('mv', 'Account');
    }
    if (isTouchDevice() && isMin1024pxWide()) {
      toggleMenu(e);
    }
  };

  const formattedGreeting = formatGreeting(greeting);
  const displayedGreeting =
    formattedGreeting === '' ? 'My account' : `Hello ${formattedGreeting}`;
  const accountLinks = getAccountLinks(accountBaseUrl, myAccountUrl);

  const wishListUrl = !signedIn
    ? `/wish-list/guest`
    : `${accountBaseUrl}/wish-list`;

  const signInUrl = `/sign-in`;
  const registerUrl = `/register`;

  return (
    <div className={styles.container}>
      {!shouldHideAccount && (
        <>
          {signedIn ? (
            <div
              className={styles.menuTrigger}
              data-test="menu-triggers"
              data-testid="menu-trigger"
              onMouseEnter={e => !isTouchDevice() && toggleMenu(e)}
              onMouseLeave={e => !isTouchDevice() && toggleMenu(e)}
            >
              <div
                className={styles.account}
                data-testid="account-button-container"
              >
                <AccountButton
                  onClick={handleOnClickSignedIn}
                  greeting={displayedGreeting}
                  myAccountUrl={myAccountUrl}
                />
                <AccountMenu isOpen={isMenuOpen} accountLinks={accountLinks} />
              </div>
            </div>
          ) : (
            <>
              <div
                className={classNames(styles.signIn, styles.desktop)}
                data-testid="account-sign-in-url"
              >
                <a href="/sign-in">Sign in</a>
              </div>
              <AccountButton
                onClick={handleOnClickSignedOut}
                myAccountUrl={myAccountUrl}
              />
            </>
          )}
        </>
      )}
      {!shouldHideWishList && (
        <AccountWishList
          wishListUrl={wishListUrl}
          signInUrl={signInUrl}
          registerUrl={registerUrl}
          signedIn={signedIn}
        />
      )}
    </div>
  );
};
